import React from "react";

import heide from "../img/heide1.jpg";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id="home">
        <div className="row">
          <div className="col-md-8">
            <h1>Gehirnpfade</h1>
            <h2 className="sub" style={{ fontSize: "25px" }}>
              unterwegs im Leben
            </h2>
            <p>
              Hier kommen ausgewählte Konzepte für Dich, um Dich persönlich und beruflich weiter zu entwickeln. Sie sind zusammengestellt
              aus mehr als 30 Jahren Berufserfahrung und bringen auf den Punkt, was wirklich funktioniert.{" "}
            </p>
            <p>
              Egal, ob Du theoretisches Vorwissen in die Praxis umsetzen möchtest oder einfach Deinen Spielraum erweitern willst, ob dies
              mehr persönlich für Dich ist oder rein beruflich-fachlich – die Erfahrung zeigt: Du entwickelst Dich erfolgreich weiter.
            </p>
          </div>
          <div className="col-md-4">
            <img src={heide} className="heide" />
          </div>
        </div>
      </div>
    );
  }
}
